module.exports = __webpack_public_path__ + "static/media/halloween5.9fe8cbf7.jpg";